export const FEE_UNIT_TYPES = {
  percentage: 'Percentage',
  fixedAmount: 'FixedAmount'
};
export const FEE_CONSTANT = {
  paperStatement: 2,
  insufficientFundsFee: 25,
  amfMaxValue: 10,
  adminMaxFee: 5
};
export const FEE_PROPERTY_TYPES = {
  lateFee: 'Late Fee',
  unitSubscriptionFee: 'Unit Subscription Fee',
  adminFee: 'Admin Fee',
  paperStatementFee: 'Paper Statement Fee'
};
export const FEES_ORIGINAL_NAMES = {
  AccountSetup: 'Account setup',
  AccountClosure: 'Account closure',
  AdminFee: 'Admin fee',
  OwnerAccountMaintenance: 'Owner account maintenance fee',
  TenantAccountMaintenance: 'Tenant account maintenance fee',
  // InsufficientFundsFee: 'Insufficient funds fee (NSF)',
  LateFee: 'Late fee (Utility billing)',
  VacancyCostRecovery: 'Vacancy cost recovery',
  PaperStatement: 'Paper statement fee'
};